/**
 * Runtime detection for PWA / install prompts.
 * Browsers keep normal chrome in a tab; installed PWAs use standalone/fullscreen display modes.
 */

/** True when the app runs from the home screen / installed shortcut (not a regular browser tab). */
export function isStandaloneDisplayMode() {
  if (typeof window === "undefined") return false;

  const standaloneMq = window.matchMedia(
    "(display-mode: standalone), (display-mode: fullscreen), (display-mode: minimal-ui)"
  );
  if (standaloneMq.matches) return true;

  // Legacy iOS Safari
  if (typeof navigator !== "undefined" && navigator.standalone === true) return true;

  // Some Android WebViews
  if (document.referrer.startsWith("android-app://")) return true;

  return false;
}

export function isIosDevice() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  const platform = navigator.platform || "";
  return (
    /iPad|iPhone|iPod/.test(ua) ||
    (platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
}

export function isAndroidDevice() {
  if (typeof navigator === "undefined") return false;
  return /Android/i.test(navigator.userAgent || "");
}

/** Chromium installability (beforeinstallprompt). */
export function supportsBeforeInstallPrompt() {
  return typeof window !== "undefined" && "BeforeInstallPromptEvent" in window;
}

export function isSecureContextForPwa() {
  if (typeof window === "undefined") return false;
  return window.isSecureContext === true;
}
